// extracted by mini-css-extract-plugin
export default {"title":"RegistrationSection_title__QAMEZ","regnInfoText":"RegistrationSection_regnInfoText__o1dtx","jumbo":"RegistrationSection_jumbo__WDlHH"};